module.exports = require("core-js-pure/stable/instance/splice");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js-stable/instance/splice.js
// module id = 600
// module chunks = 0